import { render, staticRenderFns } from "./HintItem.vue?vue&type=template&id=3996f298&lang=pug"
import script from "./HintItem.vue?vue&type=script&lang=js"
export * from "./HintItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports